<template>
  <div style="overflow:scroll" class="pl-1">
    <v-row class="pt-8">
      <v-col cols="4">
        &nbsp;{{ date | shortDate }}&nbsp;
        <v-btn @click="prevWeek">Prev Week</v-btn>
        &nbsp;
        <v-btn @click="nextWeek">Next Week</v-btn>
      </v-col>
      <v-col cols="6">
        <span>Key:</span>&nbsp;
        <span @click="filterByType('work', true)" class="key job">Day Job</span>
        <span @click="filterByType('work', false)" class="key job">Night Job</span>
        <span
            @click="showOnHoldJobs = true"
            class="key job-on-hold">
          Job On Hold
        </span>
        <span @click="filterByType('complete')" class="key complete">Complete</span>
        <span @click="filterByType('maintenance')" class="key maintenance">Maintenance</span>
        <span @click="filterByType('notes')" class="key note">Note</span>
        <span @click="filterByType('holiday')" class="key holiday">Holiday</span>
        <span @click="filterByType('surveys')" class="key survey">Survey</span>
        <span @click="fetchEvents" class="key all">All</span>
      </v-col>
    </v-row>
    <table>
      <tbody>
        <tr>
          <td>
            <table>
              <tbody>
                <tr>
                  <td class="agenda-block header"></td>
                </tr>
                <tr style="height:150px;" v-for="n in 7" :key="n">
                  <td class="agenda-block">
                    <h4 class="pl-2">{{ daysThisWeek[n - 1] | shortDate }}</h4>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td v-for="(vehicle, index) in categories" :key="index">
            <table>
              <tbody>
                <tr style="height: 50px">
                  <td class="agenda-block header">
                    <span class="number-plate">{{ vehicle.reg }}</span>
                    <!--
                    <span v-if="vehicle.chargehand" class="van-occupants">
                      <span>{{ vehicle.chargehand }}</span>
                      <span>{{ vehicle.worker }}</span>
                      <span>{{ vehicle.worker2 }}</span>
                      <span>{{ vehicle.worker3 }}</span>
                    </span>
                    -->
                  </td>
                </tr>
                <tr v-for="n in 7" :key="n">
                  <td class="agenda-block">
                    <div style="height: 150px; overflow: scroll;">
                      <div
                          v-for="(filteredEvent, index) in events"
                          :key="index">
                        <span
                          :id="filteredEvent.uniqueId"
                          draggable="true"
                          @dragstart="dragStart"
                          @click="showEvent(filteredEvent)"
                          class="event-link"
                          :class="[
                          filteredEvent.eventType,
                          { onHold: filteredEvent.onHold },
                          { complete: filteredEvent.complete },
                          { cancelled: filteredEvent.cancelled },
                          filteredEvent.color,
                        ]"
                          v-if="(filteredEvent.category === vehicle.reg) && (filteredEvent.dayNo === n)">
                        {{ filteredEvent.name }}<br />
                        {{ filteredEvent.client }}<br />
                          <span v-if="filteredEvent.site">{{ filteredEvent.site }}</span>
                          <span v-else>{{ filteredEvent.address }}</span>
                          <br />
                          <span v-for="(worker, index) in filteredEvent.workers" :key="index">
                            {{ worker }}
                          </span>
                          <br />
                          <span>Value: &pound;{{ filteredEvent.value }}</span>
                          <span
                              v-if="filteredEvent.eventType === 'work' && filteredEvent.eventTime === 'dayAM'"
                              class="day-night-indicator-text">AM</span>
                          <span
                              v-if="filteredEvent.eventType === 'work' && filteredEvent.eventTime === 'dayPM'"
                              class="day-night-indicator-text">PM</span>
                            <v-icon
                                v-if="filteredEvent.eventType === 'work' && filteredEvent.eventTime === 'night'"
                                class="day-night-indicator">mdi-moon-waning-crescent</v-icon>
                          <v-icon
                              v-if="filteredEvent.eventType === 'notes'"
                              class="day-night-indicator">mdi-pencil</v-icon>
                          <v-icon
                              v-if="filteredEvent.eventType === 'maintenance'"
                              class="day-night-indicator">mdi-wrench-outline</v-icon>
                          <v-icon
                              v-if="filteredEvent.eventType === 'holiday'"
                              class="day-night-indicator">mdi-umbrella-beach-outline</v-icon>
                          <span
                              v-if="filteredEvent.eventType === 'surveys' && filteredEvent.eventTime === 'AM'"
                              class="day-night-indicator-text">AM</span>
                          <span
                              v-if="filteredEvent.eventType === 'surveys' && filteredEvent.eventTime === 'PM'"
                              class="day-night-indicator-text">PM</span>
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  startOfWeek,
  addDays,
  format,
} from 'date-fns';
import axios from '../../axios';

export default {
  name: 'WeeklyCalendar',
  data() {
    return {
      events: [],
      eventsToExport: [],
      interval: null,
      vehicleToSave: null,
      noteToSave: null,
      firstStep: 0,
      showOnHoldJobs: false,
      getVehicleChecks: false,
      checkToday: true,
      checkDate: null,
      modal: false,
    };
  },
  computed: {
    jobAdded() {
      return this.$store.state.jobAdded;
    },
    date() {
      const today = this.$store.state.date;
      const firstDayOfTheWeek = startOfWeek(new Date(today));
      const chosenDate = firstDayOfTheWeek.setDate(firstDayOfTheWeek.getDate() + 1);
      return chosenDate;
    },
    daysThisWeek() {
      const days = [];
      const today = this.$store.state.date;
      const firstDay = startOfWeek(new Date(today));
      firstDay.setDate(firstDay.getDate() + 1);
      days.push(firstDay);
      const secondDay = addDays(firstDay, 1); days.push(secondDay);
      const thirdDay = addDays(firstDay, 2); days.push(thirdDay);
      const fourthDay = addDays(firstDay, 3); days.push(fourthDay);
      const fifthDay = addDays(firstDay, 4); days.push(fifthDay);
      const sixthDay = addDays(firstDay, 5); days.push(sixthDay);
      const seventhDay = addDays(firstDay, 6); days.push(seventhDay);
      return days;
    },
    categories() {
      console.log(this.$store.getters.allVehicleCategories);
      return this.$store.getters.allVehicleCategories;
    },
    token() {
      return this.$store.state.token;
    },
    userPermissions() {
      return this.$store.state.userPermissions;
    },
  },
  watch: {
    date() {
      this.fetchEvents();
    },
  },
  methods: {
    fetchEvents() {
      this.events = [];
      const date = format(new Date(this.date), 'yyyy-MM-dd');
      axios.get(`/plannedJobs/getWeekEvents.json?token=${this.token}&date=${date}`)
          .then((response) => {
            this.events = response.data.events;
            this.eventsToExport = response.data.eventsForExport;
            this.$store.dispatch('setWeekEvents', response.data.events);
          });
    },
    filterByType(type, day = true) {
      let events = [];
      const date = format(new Date(this.date), 'yyyy-MM-dd');
      axios.get(`/plannedJobs/getWeekEvents.json?token=${this.token}&date=${date}`)
          .then((response) => {
            events = response.data.events;
            const filtered = [];
            for (let i = 0; i < events.length; i += 1) {
              if (type === events[i].eventType) {
                if (type === 'work' && day === true) {
                  if (events[i].eventTime === 'dayAM' || events[i].eventTime === 'dayPM') {
                    filtered.push(events[i]);
                  }
                } else if (type === 'work' && day === false) {
                  if (events[i].eventTime === 'night') {
                    filtered.push(events[i]);
                  }
                } else {
                  filtered.push(events[i]);
                }
              } else if (type === 'complete') {
                if (events[i].eventType === 'work' && events[i].complete === true) {
                  filtered.push(events[i]);
                }
              }
            }
            this.events = filtered;
          });
    },
    prevWeek() {
      let date = new Date(this.date);
      date.setDate(date.getDate() - 7);
      const value = (new Date(date - (new Date()).getTimezoneOffset()
              * 60000)).toISOString().substr(0, 10);
      this.$store.commit('setDate', value);
    },
    nextWeek() {
      let date = new Date(this.date);
      date.setDate(date.getDate() + 7);
      const value = (new Date(date - (new Date()).getTimezoneOffset()
          * 60000)).toISOString().substr(0, 10);
      this.$store.commit('setDate', value);
    },
    showEvent(filteredEvent) {
      if (filteredEvent.plannedJobId > 0) this.$store.commit('selectPlannedJob', filteredEvent.plannedJobId);
      if (filteredEvent.maintenanceId > 0) this.$store.commit('selectVehicleMaintence', filteredEvent.maintenanceId);
      if (filteredEvent.noteId > 0) this.$store.commit('selectNote', filteredEvent.noteId);
      if (filteredEvent.holidayId > 0) this.$store.commit('setWorkerUnavailable', filteredEvent.holidayId);
      if (filteredEvent.surveyId > 0) this.$store.commit('setSurvey', filteredEvent.surveyId);
    },
    setUp() {
      if (this.token.length > 0) {
        axios.get(`/planningBoard/load.json?token=${this.token}`)
            .then((response) => {
              this.$store.commit('setUp', response.data);
            });
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.setUp();
      this.fetchEvents();
    }, 300);
    this.interval = setInterval(() => {
      this.fetchEvents();
    }, 30000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss">
.event-link {
  display: inline-block;
  padding: 1px 18px 1px 8px;
  border-radius: 5px;
  border: 1px solid #F0F0F0;
  cursor: pointer;
  font-size: 10px;
  max-width: 90%;
  overflow: hidden;
  position: relative;

  .day-night-indicator {
    position: absolute!important;
    top: 2px;
    right: -4px;
    font-size: 15px!important;
  }
  .day-night-indicator-text {
    position: absolute!important;
    top: 1px;
    right: 0px;
    font-size: 8px!important;
    font-style: italic;
  }

  &.cancelled {
    position: relative;
  }

  &.cancelled::after {
    content: 'CANCELLED';
    position: absolute;
    top: 25px;
    left: 2px;
    display: inline-block;
    width: 100%;
    height: 5px;
    transform: rotate(60deg);
    font-size: 18px;
    font-weight: bold;
    color: darkred;
  }

  &.work {
    background-color: #FFE0B2;

    &:hover,
    &:focus {
      background-color: #FFB74D;
    }

    &.onHold {
      background-color: #2196F3;

      &:hover,
      &:focus {
        background-color: #1976D2;
      }
    }

    &.complete {
      background-color: #FB3434;

      &:hover,
      &:focus {
        background-color: #FF0000;
      }
    }
  }

  &.maintenance {
    background-color: #FFCDD2;

    &:hover,
    &:focus {
      background-color: #E57373;
    }
  }

  &.notes {
    background-color: #B2EBF2;

    &:hover,
    &:focus {
      background-color: #4DD0E1;
    }
  }

  &.holiday {
    background-color: #F0F4C3;

    &:hover,
    &:focus {
      background-color: #DCE775;
    }
  }

  &.surveys {
    background-color: #EA80FC;

    &:hover,
    &:focus {
      background-color: #D500F9;
    }
  }
}

.agenda-block {
  position: relative;
  height: 120px;
  border-right: 1px solid #333;
  border-bottom: 1px solid #333;
  overflow-x: hidden;
  overflow-y: auto;

  &.header {
    height: 80px;
    text-align: center;
  }
}

.add-job-icon-link {
  position:absolute!important;
  top: 10px;
  right: 0;
  cursor: pointer;
  color: #FFB74D!important;
  caret-color: #FFB74D!important;

  &:hover {
    color: #F57C00!important;
    caret-color: #F57C00!important;
  }
}

.add-note-icon-link {
  position:absolute!important;
  top: 30px;
  right: 0px;
  cursor: pointer;
  color: #00BCD4!important;
  caret-color: #00BCD4!important;

  &:hover {
    color: #0097A7!important;
    caret-color: #0097A7!important;
  }
}

.key {
  display: inline-block;
  padding: 3px;
  margin-right: 5px;
  border-radius: 3px;
  cursor: pointer;

  &.job {
    background-color: #FFE0B2;
    &:hover, &:focus {
      background-color: #FFB74D;
    }
  }
  &.complete {
    background-color: #FB3434;
    &:hover, &:focus {
      color: #333;
      background-color: #FF0000;
    }
  }
  &.job-on-hold {
    background-color: #2196F3;
    &:hover, &:focus {
      color: white;
      background-color: #0288D1
    }
  }
  &.note {
    background-color: #B2EBF2;
    &:hover, &:focus {
      background-color: #4DD0E1;
    }
  }
  &.maintenance {
    background-color: #FFCDD2;
    &:hover, &:focus {
      background-color: #E57373;
    }
  }
  &.holiday {
    background-color: #F0F4C3;
    &:hover, &:focus {
      background-color: #DCE775;
    }
  }
  &.all {
    background-color: #CFD8DC;
    &:hover, &:focus {
      color: white;
      background-color: #90A4AE;
    }
  }
}

.number-plate {
  display: inline-block;
  padding: 0 4px;
  border-radius: 5px;
  text-transform: uppercase;
  font-size: 14px;
  font-family: Helvetica, Arial, Sans;
  border: 2px solid #000;
  background-color: #e6c200;
  height: 24px;
  line-height: 24px;
  position: relative;
  left: -4px;
  cursor: pointer;
}
.van-occupants {
  display: inline-block;
  font-size: 8px;
  padding-top: 5px;
  span {
    display: block;
  }
}
</style>
